(function () {
  function escapeHtml(str) {
    return (str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderProduct(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var variantId = p.variants && p.variants[0] ? p.variants[0].id : '';
    return (
      '<li class="cart-cross-sell__item">' +
        '<a href="' + escapeHtml(p.url) + '" class="cart-cross-sell__link">' +
          (img ? '<img src="' + escapeHtml(img + '&width=160') + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="80" height="80">' : '') +
          '<span class="cart-cross-sell__title">' + escapeHtml(p.title) + '</span>' +
        '</a>' +
        '<button type="button" class="cart-cross-sell__add" data-variant-id="' + escapeHtml(String(variantId)) + '">Add</button>' +
      '</li>'
    );
  }

  function loadRecommendations() {
    var container = document.getElementById('CartCrossSell');
    if (!container) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) return;
        var lastItem = cart.items[cart.items.length - 1];
        var cartProductIds = cart.items.map(function (i) { return i.product_id; });

        return fetch('/recommendations/products.json?product_id=' + lastItem.product_id + '&limit=6&intent=related')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.products || [])
              .filter(function (p) { return cartProductIds.indexOf(p.id) === -1; })
              .slice(0, 4);

            var freshContainer = document.getElementById('CartCrossSell');
            if (!freshContainer || !products.length) return;

            freshContainer.innerHTML =
              '<p class="cart-cross-sell__heading">You might also like</p>' +
              '<ul class="cart-cross-sell__list">' + products.map(renderProduct).join('') + '</ul>';
            freshContainer.hidden = false;
          });
      })
      .catch(function (e) { console.error(e); });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.cart-cross-sell__add');
    if (!btn) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled) return;
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cartDrawer.renderContents) cartDrawer.renderContents(response);
      })
      .catch(function (e) {
        console.error(e);
        btn.disabled = false;
      });
  });

  var debounceTimer;
  function scheduleLoad() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(loadRecommendations, 150);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    new MutationObserver(function () {
      if (drawer.classList.contains('active')) scheduleLoad();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    new MutationObserver(scheduleLoad).observe(drawer, { childList: true, subtree: true });
  });
})();
